import {Injectable} from '@angular/core';
import {
  DEPARTMENT_STORAGE_KEY,
  EMPTY_TEXT,
  GROUP_NAME_STORAGE_KEY,
  GROUP_REPORT_STORAGE_MARKER,
  REPORT_DATE_FROM_STORAGE_KEY,
  REPORT_DATE_STORAGE_KEY,
  REPORT_DATE_TO_STORAGE_KEY,
  REPORT_TARGET_STORAGE_KEY,
  REPORTS_STORAGE_KEY,
  VECTOR_STORAGE_KEY
} from './report-datepicker.constants';
import {
  GroupReportStorageContext,
  PersonalReportStorageContext
} from './report-datepicker.types';

const EXTERNAL_LINK_TARGET = '_blank';
const EXTERNAL_LINK_FEATURES = 'noopener';

@Injectable()
export class ReportDatepickerPlatform {
  storeDepartment(department: Object): void {
    localStorage.setItem(DEPARTMENT_STORAGE_KEY, JSON.stringify(department));
  }

  storeVector(vector: Object): void {
    localStorage.setItem(VECTOR_STORAGE_KEY, JSON.stringify(vector));
  }

  storePersonalReport(context: PersonalReportStorageContext): void {
    this.storeReportContext(context);
    localStorage.setItem(REPORT_TARGET_STORAGE_KEY, EMPTY_TEXT);
  }

  storeGroupReport(context: GroupReportStorageContext): void {
    this.storeReportContext(context);
    localStorage.setItem(GROUP_NAME_STORAGE_KEY, context.groupName);
    localStorage.setItem(REPORT_TARGET_STORAGE_KEY, GROUP_REPORT_STORAGE_MARKER);
    localStorage.setItem(REPORT_GROUP_ID_STORAGE_KEY, context.groupId || EMPTY_TEXT);
  }

  openExternal(url: string): void {
    window.open(url, EXTERNAL_LINK_TARGET, EXTERNAL_LINK_FEATURES);
  }

  schedule(action: () => void, delay: number): void {
    setTimeout(action, delay);
  }

  private storeReportContext(context: PersonalReportStorageContext): void {
    localStorage.setItem(REPORT_DATE_FROM_STORAGE_KEY, context.from);
    localStorage.setItem(REPORT_DATE_TO_STORAGE_KEY, context.to);
    localStorage.setItem(REPORT_DATE_STORAGE_KEY, context.reportDate);
    localStorage.setItem(REPORTS_STORAGE_KEY, JSON.stringify(context.reports));
  }
}

const REPORT_GROUP_ID_STORAGE_KEY = 'ReportGroupId';



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/modals/report-datepicker.platform.ts